import React from 'react';
import { Alert, Badge } from 'react-bootstrap';

const object = (value: unknown): Record<string, unknown> => value && typeof value === 'object' && !Array.isArray(value) ? value as Record<string, unknown> : {};
const text = (value: unknown): string => typeof value === 'string' ? value : '';
const texts = (value: unknown): string[] => Array.isArray(value) ? value.filter((item): item is string => typeof item === 'string') : [];

export const controlFramework = (attributes: Record<string, unknown>): string => {
  const source = object(attributes.adoptech);
  const relations = Array.isArray(source.frameworks_relations) ? source.frameworks_relations : [];
  return text(attributes.frameworkEdition) || relations.map((relation) => text(object(object(relation).framework).name)).filter(Boolean).join(', ');
};

const IntegratedManagementControlDetails: React.FC<{ type: string; attributes: Record<string, unknown>; standards: string[] }> = ({ type, attributes, standards }) => {
  if (!['controls', 'requirements'].includes(type)) return null;
  const source = object(attributes.adoptech);
  const description = text(attributes.description) || text(source.description);
  const implementation = text(attributes.implementation) || text(source.treatment_plan);
  const evidence = texts(attributes.expectedEvidence);
  const refs = texts(attributes.requirementRefs);
  const mapped = texts(attributes.mappedControls);
  const state = text(attributes.criteriaState);
  return <section aria-label="Control and requirement mapping" className="mb-4">
    <h3 className="h6">{type === 'requirements' ? 'Requirement mapping' : 'Control implementation'}</h3>
    <p>{standards.length ? standards.map((standard) => <Badge className="me-1" bg="secondary" key={standard}>{standard}</Badge>) : 'Outside the four ISO mappings'}</p>
    {controlFramework(attributes) && <p><strong>Framework / edition:</strong> {controlFramework(attributes)}</p>}
    {refs.length > 0 && <p><strong>Reference areas:</strong> {refs.join(', ')}</p>}
    {state && <Alert variant="warning">{state}</Alert>}
    {description && <><h4 className="h6">Description</h4><p style={{ whiteSpace: 'pre-wrap' }}>{description}</p></>}
    {implementation && <><h4 className="h6">Gemstone’s arrangement / preparation</h4><p style={{ whiteSpace: 'pre-wrap' }}>{implementation}</p></>}
    {mapped.length > 0 && <><h4 className="h6">Mapped controls</h4><ul>{mapped.map((control) => <li key={control}>{control}</li>)}</ul></>}
    {evidence.length > 0 && <><h4 className="h6">Evidence required for verification</h4><ul>{evidence.map((item) => <li key={item}>{item}</li>)}</ul></>}
    {text(attributes.gap) && <Alert variant="info"><strong>Outstanding:</strong> {text(attributes.gap)}</Alert>}
    {typeof source.applicable === 'boolean' && <p><strong>Historical applicability:</strong> {source.applicable ? 'Included in source' : 'Excluded in source'}{text(source.reason_for_exclusion) && ` — ${text(source.reason_for_exclusion)}`}. Not a new applicability decision.</p>}
  </section>;
};

export default IntegratedManagementControlDetails;
